export default "__VITE_ASSET__BJy4ip39__"